import React from "react";
// import { Control, Form, actions } from 'react-redux-form';
import { Field, Formik, Form } from "formik";

import { connect } from "react-redux";
import { contactFormOperations } from "./duck/index";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";

class ContactUs extends React.Component {
  handleSubmit({ message }) {
    this.props.sendContactMessage({ message });
  }

  errorMessage() {
    if (this.props.success) {
      return <div className="info-green">{this.props.success}</div>;
    }
  }

  componentDidUpdate() {
    this.props.clearValues();
  }

  render() {
    return (
      <div className="login">
        {/* mock PI-5888  */}
        <Formik
          initialValues={{
            firstName: "",
            lastName: "",
            email: "",
          }}
          onSubmit={async (values) => {
            await new Promise((r) => setTimeout(r, 500));
            alert(JSON.stringify(values, null, 2));
          }}
        >
          <Form>
            <label htmlFor="firstName">First Name</label>
            <Field id="firstName" name="firstName" placeholder="Jane" />

            <label htmlFor="lastName">Last Name</label>
            <Field id="lastName" name="lastName" placeholder="Doe" />

            <label htmlFor="email">Email</label>
            <Field
              id="email"
              name="email"
              placeholder="jane@acme.com"
              type="email"
            />
            <button type="submit">Submit</button>
          </Form>
        </Formik>
        {this.errorMessage()}
      </div>
    );
  }
}

ContactUs.propTypes = {
  sendContactMessage: PropTypes.func,
  clearValues: PropTypes.func,
  success: PropTypes.bool,
};

const mapStateToProps = (state) => {
  return {
    success: state.contactUsReducer.success,
    authenticated: state.userData.authenticated,
  };
};
const mapDispatchToProps = (dispatch) => ({
  sendContactMessage: (userMessage) =>
    dispatch(contactFormOperations.sendContactMessage(userMessage)),
  clearValues: () => dispatch(actions.reset("contactUs")),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ContactUs)
);
